<template>
  <div :id="`question_${index + 1}`" class="py-4 flex">
    <span class="w-20 py-5 px-6 text-3xl leading-relaxed absolute transform -translate-y-3 lg:translate-y-0"
          :class="{ [correctClass]: examTypeQuiz }"
    >{{ index + 1 }}</span>
    <div :class="[
      'min-w-0 py-3 flex-1 lg:pl-20 lg:py-5',
      [ isMobile ? 'pl-20' : 'pl-14' ]
    ]">
      <template>
        <div class="-ml-20 pl-20 flex items-start gap-x-1">
          <p class="w-full rounded-lg py-2.5 px-5 bg-gray-100">{{ question.questionTitle }}</p>
          <div class="flex items-center gap-x-1"
               v-if="examTypeQuiz"
          >
            <GrmTextField type="number" :value="question.questionScore" class="w-20" disabled />
            <span class="text-xs">{{ $t('exam.question.point') }}</span>
          </div>
        </div>
      </template>
      <div class="mt-2 flex flex-col gap-y-2">
        <div v-for="answer in question.answerList"
             :key="answer.answerId"
             class="flex items-start gap-x-1"
        >
          <p v-if="answer.answerText" class="rounded-lg p-4 bg-blue-50 text-sm break-all">{{ answer.answerText }}</p>
        </div>
        <div v-for="userAnswer in question.userAnswerList"
             :key="userAnswer.userAnswerId"
             class="flex items-start"
        >
          <p class="border border-blue-400 rounded-lg p-4 text-sm break-all">{{ userAnswer.answerText }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GrmTextField from "@/components/Common/textField/GrmTextField.vue";
import {Device} from "@/utils";

export default {
  name: 'TestbankHistoryQuestionSubjective',
  components: {
    GrmTextField,
  },
  props: {
    index: { type: Number, default: 0 },
    question: { type: Object, default: () => ({}) },
    examTypeQuiz: { type: Boolean, default: false }
  },
  computed: {
    correctClass() {
      const { answerList, userCorrectAnswerCnt, } = this.question;
      if (
        !!answerList.length
        && !!userCorrectAnswerCnt
        && answerList.length === userCorrectAnswerCnt
      ) {
        return 'bg-exam-mark-correct';
      } else if (!userCorrectAnswerCnt) {
        return 'bg-exam-mark-wrong';
      } else {
        return 'bg-exam-mark-part';
      }
    },
    isMobile(){
      return Device.isMobile();
    },
  }
}
</script>